import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { joinJSXElements } from "@msuite/ui/utils";
import { moment } from "@msuite/utils/date";
import { capitalize, guardString } from "@msuite/utils/strings";
import type { ParscCalculation } from "@msuite/utils/types";
import { OrganizationCard, TicketTypeIcon } from "@/components/cards";

const columnHelper = createColumnHelper<ParscCalculation>();

export const columns = [
	columnHelper.accessor((row) => row._ticketAssignmentReference._crew._plan.date, {
		header: localized("dates.date"),
		cell: (cell) => moment(cell.getValue()).dateFormat(),
	}),
	columnHelper.accessor((row) => row._ticketAssignmentReference._crew.ranking, {
		header: capitalize(localized("planning.crews.crew")),
		cell: (cell) => (
			<OrganizationCard
				orgId={cell.row.original._ticketAssignmentReference._crew.orgId}
				render={(org) => (
					<p>
						{guardString(org?.name)} {cell.row.original._ticketAssignmentReference._crew.ranking}
					</p>
				)}
			/>
		),
	}),
	columnHelper.accessor((row) => row._ticketAssignmentReference._project.name, {
		header: localized("projects.project"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => row._ticketAssignmentReference._ticketAssignments.length, {
		header: localized("projects.tickets"),
		cell: (cell) => (
			<div className="h-stack">
				{joinJSXElements(
					cell.row.original._ticketAssignmentReference._ticketAssignments.map((t) => (
						<div
							key={t.id}
							className="h-stack"
						>
							<TicketTypeIcon ticketTypeId={t._ticket._ticketType.id} />
							<p>{t._ticket.description}</p>
						</div>
					)),
					["/"],
				)}
			</div>
		),
	}),
];
